<template>
  <div>
    <b-modal
      v-model="modalShow"
      header-bg-variant="info"
      header-text-variant="light"
      hover
      responsive
      size="xl"
      @ok="okModal"
      @cancel="cancelModal"
    >
        <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="success" @click="ok()">Chọn</b-button>
        <b-button variant="danger" @click="cancel()">Đóng</b-button>
      </template>
      <b-table
        bordered
        head-variant="dark"
        hover
        responsive
        :fields="fields"
        :items="items"
        selectable
        select-mode="multi"
        @row-selected="onRowSelected"
        ref="itemTable"
      >
        <template v-slot:head(selected)="data">
          <input type="checkbox" @click="selectAllRows()" v-model="checkAll" />
        </template>
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <template v-slot:modal-title>
          <div>Thủ tục tiếp nhận</div>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
          <b-button variant="success" @click="ok()">Đồng ý</b-button>
          <b-button variant="danger" @click="cancel()">Hủy bỏ</b-button>
        </template>
        <template v-slot:cell(nhomthutuc)="data">
          <div
            v-if="data.item.nhomthutuc != null"
          >{{nhomthutucs.find(x => x.id === data.item.nhomthutuc).pickListValue}}</div>
        </template>
      </b-table>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ThuTucModal",
  props: ["show", "idthutuc", "nhomthutucs", "items"],
  data() {
    return {
      modalShow: false,
      fields: [
        {
          key: "selected",
          label: "",
          thStyle: { width: "5% !important" },
        },
        {
          key: "tenthutuc",
          label: "Tên thủ tục",
        },
        {
          key: "nhomthutuc",
          label: "Nhóm thủ tục",
        },
        {
          key: "ghichu",
          label: "Ghi chú",
        },
      ],
      checkAll: false,
      selected: [],
    };
  },
  watch: {
    show: function (newValue, oldValue) {
      this.modalShow = newValue;
    },
  },
  methods: {
    cancelModal() {
      this.$emit("cancelModal");
    },
    okModal() {
      this.$emit("okModal", this.selected);
    },
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows(data) {
      if (this.checkAll == false) this.$refs.itemTable.selectAllRows();
      else this.$refs.itemTable.clearSelected();
    },
  },
};
</script>